import { useMutation } from '@apollo/client';
import { graphql } from '../gql';
// import { GET_RATER } from './rater.query';

const UPSERT_ANSWERS_MUTATION = graphql(`
  mutation upsertAnswers($data: SaveAnswersInput!) {
    upsertAnswers(data: $data) {
      uuid
      sectionUuid
      subSectionUuid
      subSection
      order
      type
      answer {
        uuid
        answer
        type
        createdAt
        updatedAt
      }
    }
  }
`);

export function useUpsertAnswersMutation() {
  const [
    upsertAnswers,
    {
      loading: saveAnswersIsLoading,
      error: saveAnswersError,
      reset: saveAnswersReset,
    },
  ] = useMutation(UPSERT_ANSWERS_MUTATION, {
    awaitRefetchQueries: true,
  });

  return {
    upsertAnswers,
    saveAnswersIsLoading,
    saveAnswersError,
    saveAnswersReset,
  };
}
